export default "../../src/img/loading.gif";